import $http from '../../axios';
import {Notification, MessageBox} from 'element-ui';

export async function fetchUsers({commit, state,rootState,dispatch}, requestParameters = {params: state.params}
) {
    let subscriber = JSON.parse(localStorage.getItem('subscriber'))

    await dispatch("users/fetchUsers",
        {
            params: {
                subscriber_id: subscriber ? subscriber.id : 3,
                paginate: false
            }
        },
        { root: true }

    );
    commit("setUsers", rootState.users.users);

}
export async function fetchLines({ dispatch, state, rootState, commit }) {
    await dispatch(
        "lines/fetchLines",
        { params: { paginate: false } },
        { root: true }
    );
    commit("setLines", rootState.lines.lines);
}
export async function fetchBrands({ dispatch, state, rootState, commit }) {
    await dispatch(
        "brands/fetchBrands",
        { params: { paginate: false, lines: state.params_config.lines } },
        { root: true }
    );
    commit("setBrands", rootState.brands.brands);
}
export async function searchProducts({ state, commit },filter){
    let params ={
        filter : filter,
        paginate : false,
        branchoffice_id: state.params_config.branch_office_id ? state.params_config.branch_office_id : localStorage.selected_branchoffice,
        branchoffice_warehouse_id:state.params_config.branch_office_warehouse_id? state.params_config.branch_office_warehouse_id : localStorage.selected_branchoffice_warehouse
    }
    await $http.get('/api/lista-productos', {params}).then((response) => {
        commit('setProducts', response.data.data.data)
    })

}
export async function fetchPhysicalInventory({ state, commit }) {
    state.loading.module = true
    await $http
        .post("/api/physical-inventory", state.params_config)
        .then(response => {
            commit("setPhysicalInventory", response.data.data);
            state.loading.module = false
        })
        .catch(error => {
            state.loading.module = false
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}
export async function fetchAddProductPhysicalInventory({ state, commit },product_id) {
    state.loading.module = true
    await $http
        .post("/api/physical-inventory/add-product",{
            'product_id' :product_id,
            'physicalInventory_id' :state.physicalInventory.id,
            'branch_office_warehouse_id' :state.physicalInventory.branch_office_warehouse_id,
            'branch_office_id' :state.physicalInventory.branch_office_id,
        })
        .then(response => {
            state.loading.module = false
            commit("setPhysicalInventory", response.data.data);
        })
        .catch(error => {
            state.loading.module = false
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}
export async function searchPhysicalInventoryByUser({ state, commit }, ) {
    state.params_config.branch_office_id =  state.params_config.branch_office_id ? state.params_config.branch_office_id : localStorage.selected_branchoffice
    state.params_config.branch_office_warehouse_id =  state.params_config.branch_office_warehouse_id ? state.params_config.branch_office_warehouse_id : localStorage.selected_branchoffice_warehouse

    await $http
        .get("/api/physical-inventory", { params : state.params_config} )
        .then(response => {
            commit("setPhysicalInventory", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.response.data.messagee,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}
export async function updatePhysicalInventoryProduct({ state, commit },row) {
    state.loading.module = true
    await $http
        .post(`/api/physical-inventory/product/${row.id}`, row )
        .then(response => {
            state.loading.module = false
            commit("setPhysicalInventory", response.data.data);
        })
        .catch(error => {
            state.loading.module = false
            Notification.error({
                title: "Error!",
                message: error.response.data.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}
export async function consolidateCountingPhysicalInventory({ state, commit },id) {
    state.loading.module = true
    await $http
        .post(`/api/physical-inventory/consolidate-counting/${id}`)
        .then(response => {
            state.loading.module = false
            commit("setPhysicalInventory", response.data.data);
        })
        .catch(error => {
            state.loading.module = true
            Notification.error({
                title: "Error!",
                message: error.response.data.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}
export async function applySettingsPhysicalInventory({ state, commit },id) {
    state.loading.module = true
    await $http
        .post(`/api/physical-inventory/apply-settings/${id}`)
        .then(response => {
            state.loading.module = false
            commit("setPhysicalInventory", response.data.data);
        })
        .catch(error => {
            state.loading.module = false
            Notification.error({
                title: "Error!",
                message:error.response.data.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}
export async function finalizePhysicalInventory({ state, commit },id) {
    state.loading.module = true
    await $http
        .post(`/api/physical-inventory/finalize/${id}`)
        .then(response => {
            commit("setFinalizeInventory", response.data.data);
            state.loading.module = false
        })
        .catch(error => {
            state.loading.module = false
            Notification.error({
                title: "Error!",
                message: error.response.data.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}

export async function getCounts({ state, commit },data) {
    state.loading.module = true
    await $http
        .get(`/api/physical-inventory/get-counts-by-product/${data[0]}/${data[1]}`)
        .then(response => {
            commit("setCounts", response.data.data);
            state.loading.module = false
        })
        .catch(error => {
            state.loading.module = false
            Notification.error({
                title: "Error!",
                message: error.response.data.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}
export async function fetchFinalizeCountingUser({ state, commit,dispatch }) {
    state.loading.module = true
    await $http
        .post(`/api/physical-inventory/update-counting-state/${state.physicalInventory.id}`)
        .then(response => {
            commit("setPhysicalInventory", response.data.data);
            Notification.success({
                title: "Success!",
                message: 'Se ha finalizado el conteo Exitosamente',
                type: "success",
                duration: 1500,
                customClass: "notification-box"
            });
            state.loading.module = false
        })
        .catch(error => {
            state.loading.module = false
            Notification.error({
                title: "Error!",
                message: error.response.data.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}
export async function fetchRevertCountingUser({ state, commit,dispatch },row) {
    state.loading.module = true
    await $http
        .post(`/api/physical-inventory/revert-counting-state/${row.physical_inventory_id}/${row.user_id}`)
        .then(response => {
            commit("setPhysicalInventory", response.data.data);
            Notification.success({
                title: "Success!",
                message: 'Se ha finalizado el conteo Exitosamente',
                type: "success",
                duration: 1500,
                customClass: "notification-box"
            });
            state.loading.module = false
        })
        .catch(error => {
            state.loading.module = false
            Notification.error({
                title: "Error!",
                message: error.response.data.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}

export async function fetchResetCountingState({ state, commit }) {
    state.loading.module = true
    await $http
        .post(`/api/physical-inventory/reset-counting-state/${state.physicalInventory.id}`)
        .then(response => {
            commit("setPhysicalInventory", response.data.data);
            state.loading.module = false
        })
        .catch(error => {
            state.loading.module = false
            Notification.error({
                title: "Error!",
                message: error.response.data.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}
export async function fetchCountingStateUsers({ state, commit }) {
    await $http
        .get(`/api/physical-inventory/get-counts-users/${state.physicalInventory.id}`)
        .then(response => {
            commit("setCountingStateUsers", response.data.data);
            state.loading.module = false
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.response.data.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}

export async function resetInventory({ state, commit }) {
    await $http
        .post(`/api/physical-inventory/reset/${state.physicalInventory.id}`)
        .then(response => {
            commit("setPhysicalInventory", response.data.data);
            state.loading.module = false
            Notification.success({
                title: "Success!",
                message: 'Se ha restablecido el conteo Exitosamente',
                type: "success",
                duration: 1500,
                customClass: "notification-box"
            });
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.response.data.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}



// WEBPACK FOOTER //
// ./src/modules/physical-inventory/actions.js